import styled from "styled-components";
import LwwTicketBody from "../../components/LwwTickets/LwwTicketBody";
import LwwTicketsHeader from "../../components/LwwTickets/LwwTicketsHeader";
const CURRENT_PAGE = 1;
const LIMIT = 10;
const QUERY = "";

const LWWTicket = () => {

    return (
        <>
            {/* <LwwTicketsHeader /> */}
            <LwwTicketBody />
        </>
    );
};

const MechantPageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export default LWWTicket;
